import { getDomain } from '../../utils/config';

const domain = getDomain();

export const FOOTER_LINKS = [
	{
		id: 'termsOfSale',
		url: `https://www.${domain}/terms-and-conditions`
	},
	{
		id: 'doNotSellMyPersonalInformation',
		url: `https://www.${domain}/do-not-sell-my-personal-information`
	},
	{
		id: 'termsOfUse',
		url: `https://www.${domain}/terms-of-use`
	},
	{
		id: 'cookiePolicy',
		url: `https://www.${domain}/privacy-policy/cookie-policy`
	},
	{
		id: 'privacyPolicy',
		url: `https://www.${domain}/privacy-policy`
	}
];
